import React from "react";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import MainButton from "../../Elements/MainButton/MainButton";

import successIcon from "../../../assets/icons/flash-message/success.png";
import errorIcon from "../../../assets/icons/flash-message/exclamation.png";

import "./StatusModal.css";

const StatusModal = ({ isOpen, type = "success", isLoggedIn = false, isPayPal = false, onClose, customMessage }) => {
  const { t, i18n } = useTranslation();
  const currentLang = i18n.language || "en";

  if (!isOpen) return null;

  const isSuccess = type === "success";

  const handleOverlayClick = () => {
    if (isSuccess) {
      onClose();
      window.location.href = `/${currentLang}/cart`;
    } else {
      onClose();
    }
  };

  const handleSuccessPrimaryClick = () => {
    onClose();

    if (isLoggedIn) {
      window.location.href = `/${currentLang}/esim`;
    } else {
      window.location.href = `/${currentLang}/shop`;
    }
  };

  const handleCanceledPrimaryClick = () => {
    onClose();
    window.location.href = `/${currentLang}/cart`;
  };

  const message = isSuccess
    ? isPayPal
      ? t("cart.paypalEsimDelay")
      : isLoggedIn
        ? t("cart.esimDetailsInMenu")
        : t("cart.esimInEmail")
    : customMessage || t("cart.cartWaiting");

  const successButtonLabel = isLoggedIn ? t("cart.seeEsims") : t("offers.continueShopping");

  return (
    <div className="status-modal-overlay" onClick={handleOverlayClick}>
      <div className="status-modal" onClick={(e) => e.stopPropagation()}>
        <div className="status-modal-icon">
          <img src={isSuccess ? successIcon : errorIcon} alt={isSuccess ? "Success" : "Warning"} />
        </div>

        <h2 className={`status-modal-title ${isSuccess ? "success" : "canceled"}`}>
          {isSuccess ? t("cart.paymentSuccessful") : t("cart.paymentCanceled")}
        </h2>

        <p className="status-modal-message">{message}</p>

        <div className="status-modal-actions">
          {isSuccess ? (
            <MainButton onClick={handleSuccessPrimaryClick} className="status-btn">
              {successButtonLabel}
            </MainButton>
          ) : (
            <MainButton onClick={handleCanceledPrimaryClick} className="status-btn">
              {t("cart.backToCart")}
            </MainButton>
          )}
        </div>
      </div>
    </div>
  );
};

StatusModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  type: PropTypes.oneOf(["success", "canceled"]),
  isLoggedIn: PropTypes.bool,
  isPayPal: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  customMessage: PropTypes.string,
};

export default StatusModal;
